import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  storeId: null,
  storeName: null,
};


const storeSlice = createSlice({
  name: 'store',
  initialState,
  reducers: {
    setStoreId: (state, action) => {
      state.storeId = action.payload;
    },
    setStoreName: (state, action) => {
      state.storeName = action.payload;
    },
    clearStoreId: (state) => {
      state.storeId = null;
    },
  },
});

export const { setStoreId, clearStoreId, setStoreName } = storeSlice.actions;
export const storeReducer = storeSlice.reducer;